module.exports = __webpack_public_path__ + "static/media/googleCloud_logo.ca68621e.svg";